export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  maxWidth: 1200,
  minHeight: "10vh",
  maxHeight: "80vh",
  overflow: "auto",
};
